/**
 * comunicacaoBuilder — aulas ao vivo, materiais de apoio, manuais, mensagens.
 *
 * @since H.4 (pedagógico novo)
 */
import type { $Fetch } from 'ofetch';
import { HttpCommunicationFileGateway } from '@/infrastructure/http/HttpCommunicationFileGateway';
import { UploadCommunicationFile, DownloadCommunicationFile } from '@/application/usecase/CommunicationFileUseCaseImpl';

import {
  HttpAulaGateway, HttpMaterialApoioGateway, HttpManualGateway, HttpMensagemGateway,
} from '@/infrastructure/http/HttpComunicacaoGateways';
import {
  ListAulasAoVivo, CreateAulaAoVivo, UpdateAulaAoVivo, ArquivarAulaAoVivo,
  ListMateriais, CreateMaterial, UpdateMaterial, ArquivarMaterial,
  ListManuais, CreateManual, UpdateManual, ArquivarManual,
  EnviarMensagem, ListMensagensByAluno,
} from '@/application/usecase/ComunicacaoUseCaseImpl';

export function buildComunicacaoSlice(httpClient: $Fetch) {
  const aulaGateway = new HttpAulaGateway(httpClient);
  const materialGateway = new HttpMaterialApoioGateway(httpClient);
  const manualGateway = new HttpManualGateway(httpClient);
  const mensagemGateway = new HttpMensagemGateway(httpClient);

  const files = new HttpCommunicationFileGateway(httpClient);
  const useCases = {
    uploadCommunicationFile: new UploadCommunicationFile(files),
    downloadCommunicationFile: new DownloadCommunicationFile(files),
    listAulasAoVivo: new ListAulasAoVivo(aulaGateway),
    createAulaAoVivo: new CreateAulaAoVivo(aulaGateway),
    updateAulaAoVivo: new UpdateAulaAoVivo(aulaGateway),
    arquivarAulaAoVivo: new ArquivarAulaAoVivo(aulaGateway),
    listMateriais: new ListMateriais(materialGateway),
    createMaterial: new CreateMaterial(materialGateway),
    updateMaterial: new UpdateMaterial(materialGateway),
    arquivarMaterial: new ArquivarMaterial(materialGateway),
    listManuais: new ListManuais(manualGateway),
    createManual: new CreateManual(manualGateway),
    updateManual: new UpdateManual(manualGateway),
    arquivarManual: new ArquivarManual(manualGateway),
    enviarMensagem: new EnviarMensagem(mensagemGateway),
    listMensagensByAluno: new ListMensagensByAluno(mensagemGateway),
  };

  return { useCases };
}
